import { registerAccountApplicationSagas } from './accountApplication.saga';
import accountDetails from './accountDetails';
import { registerAccountHolderSagas } from './accountHolders.sagas';
import { registerAccountSagas } from './accounts.sagas';
import cashieringSaga from './cashiering';
import { registerCommonSagas } from './common.saga';
import configs from './configs';
import investigations from './investigations';
import offerOrders from './offerOrders.sagas';
import offersSaga from './offers.sagas';
import offerWatches from './offerWatches.sagas';
import orders from './orders.sagas';
import { registerPositionSagas } from './position.saga';
import { registerQuoteSagas } from './quote.saga';
import registerStatementsSagas from './statements.sagas';
import user from './users.sagas';

/**
 * Register all sagas
 */
export default [
  registerCommonSagas,
  user,
  registerAccountHolderSagas,
  registerAccountSagas,
  registerAccountApplicationSagas,
  registerStatementsSagas,
  accountDetails,
  cashieringSaga,
  offersSaga,
  investigations,
  configs,
  orders,
  registerPositionSagas,
  registerQuoteSagas,
  offerOrders,
  offerWatches,
];
